import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import config from './config/config';
import Home from './component/home';
import Home2 from './component/home2';
import Launchprocess from './component/launchprocess';
import Dashboard from './component/dashboard';
import Project from './component/dashboard/Project';
import ProjectOverview from './component/dashboard/ProjectOverview';
import Learn from './component/learn';
import WhatIsUtx from './component/whatisutx';
import Empoweringfeatures from './component/empoweringfeatures';
import Roadmap from './component/road_map';
import UnitronixExplained from './component/unitronixexplianed';
import Ourstrategy from './component/ourstrategy';
import Empowerfeature from './component/empowerfeature';
import Portfolio from './component/portfolio';
import Howitwork from './component/howitwork';
import Contact from './component/contact';
import Blog from './component/blog';
import NewsReadMore from './component/newsreadmore';
import News from './component/news';
import Termsofuse from './component/termsofuse';
import PrivacyPolicy from './component/privacypolicy';
import Podcast from './component/podcast';
import Press from './component/pressrelease';
import Forinvestor from './component/forinvestor';
import Projectowner from './component/projectowner';
import Howitwork2 from './component/howitwork2';
import AppHome from './component/appHome';

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route path={`${config.baseUrl}`} element={<Home />} />

          <Route
            path={`${config.baseUrl}unitronixexplained`}
            element={<UnitronixExplained />}
          />
          <Route
            path={`${config.baseUrl}ourstrategy`}
            element={<Ourstrategy />}
          />
          <Route
            path={`${config.baseUrl}empowerfeature`}
            element={<Empowerfeature />}
          />
          <Route path={`${config.baseUrl}portfolio`} element={<Portfolio />} />
          <Route path={`${config.baseUrl}roadmap`} element={<Roadmap />} />
          <Route path={`${config.baseUrl}howitwork`} element={<Howitwork />} />
          <Route path={`${config.baseUrl}contact`} element={<Contact />} />
          <Route path={`${config.baseUrl}blog`} element={<Blog />} />
          <Route
            path={`${config.baseUrl}newsreadmore`}
            element={<NewsReadMore />}
          />
          <Route path={`${config.baseUrl}news`} element={<News />} />
          <Route path={`${config.baseUrl}pressrelease`} element={<Press />} />

          <Route path={`${config.baseUrl}learn`} element={<Learn />} />
          <Route path={`${config.baseUrl}whatisutx`} element={<WhatIsUtx />} />
          <Route
            path={`${config.baseUrl}empoweringfeatures`}
            element={<Empoweringfeatures />}
          />

          <Route path={`${config.baseUrl}home`} element={<Home2 />} />

          {/* -----New pages-------- */}

          <Route
            path={`${config.baseUrl}apphome`}element={<AppHome />}/>
          <Route path={`${config.baseUrl}forinvestor`} element={<Forinvestor />} />
          <Route path={`${config.baseUrl}projectowner`} element={<Projectowner />} />
          <Route path={`${config.baseUrl}howitwork2`} element={<Howitwork2 />} />

          {/* -------------- */}

          <Route
            path={`${config.baseUrl}launchprocess`}
            element={<Launchprocess />}
          />

          <Route path={`${config.baseUrl}dashboard`} element={<Dashboard />} />
          <Route path={`${config.baseUrl}project`} element={<Project />} />
          <Route
            path={`${config.baseUrl}projectoverview/:id`}
            element={<ProjectOverview />}
          />

          {/* ----------- */}
          <Route
            path={`${config.baseUrl}termsofuse`}
            element={<Termsofuse />}
          />
          <Route
            path={`${config.baseUrl}privacypolicy`}
            element={<PrivacyPolicy />}
          />
          <Route path={`${config.baseUrl}podcast`} element={<Podcast />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
export default App;
